module.exports = __webpack_public_path__ + "img/cname.72804fb4.jpg";